import correlativesAdminApi from '../../api/settings/correlativesAdminApi';

/**
 * 🔢 CorrelativesAdminService
 *
 * Servicio frontend para la administración de correlativos
 * (Settings → Administración de Correlativos)
 */
const CorrelativesAdminService = {

    /**
     * 📄 Lista todas las secuencias de documentos
     * GET /api/settings/correlatives
     */
    listSequences: async () => {
        const response = await correlativesAdminApi.fetchCustom('');
        return response.data;
    },

    /**
   * 📄 Obtiene una secuencia por ID
   * GET /api/settings/correlatives/{id}
   */
    getById: async (sequenceId: number) => {
        const response = await correlativesAdminApi.fetchCustom(`/${sequenceId}`);
        return response.data;
    },

    /**
     * 🔄 Restablece una secuencia específica
     * POST /api/settings/correlatives/{sequenceId}/reset
     */
    resetSequence: async (sequenceId: number) => {
        const response = await correlativesAdminApi.addCustom(
            `/${sequenceId}/reset`,
            {}
        );
        return response.data;
    },

    /**
     * 🔄 Restablece todas las secuencias del sistema
     * POST /api/settings/correlatives/reset-all
     */
    resetAllSequences: async () => {
        const response = await correlativesAdminApi.addCustom(
            '/reset-all',
            {}
        );
        return response.data;
    },

};

export default CorrelativesAdminService;
